module.exports = __webpack_public_path__ + "fonts/Renault-Global.woff";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/icons/Renault-Global.woff
// module id = 368
// module chunks = 0